import React from 'react';
import { FaPlay, FaRedo, FaHome, FaQuestionCircle, FaTrophy } from 'react-icons/fa';
import Button from '../common/Button';
import Modal from '../common/Modal';

const PauseMenu = ({ isOpen, onResume, onRestart, onMenu, onHelp, onAchievements }) => {
  return (
    <Modal isOpen={isOpen} onClose={onResume} title="遊戲暫停">
      <div className="flex flex-col gap-3">
        <Button 
          onClick={onResume} 
          variant="primary" 
          className="w-full"
        >
          <FaPlay /> 繼續遊戲
        </Button>
        
        <div className="grid grid-cols-2 gap-3">
          <Button 
            onClick={onRestart} 
            variant="secondary" 
            size="sm"
          >
            <FaRedo /> 重新開始
          </Button>
          
          <Button 
            onClick={onMenu} 
            variant="secondary" 
            size="sm"
          >
            <FaHome /> 主選單
          </Button>
          
          <Button 
            onClick={onHelp} 
            variant="accent" 
            size="sm"
          >
            <FaQuestionCircle /> 幫助
          </Button>
          
          <Button 
            onClick={onAchievements} 
            variant="accent" 
            size="sm"
          >
            <FaTrophy /> 成就
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PauseMenu;